const APP = require('APP')
const _ = require('underscore')

const { translations } = APP

delete APP.translations

function replaceFn(translated, val, key) {
  return translated.split(key).join(val)
}

function trans(key, replaceObj) {
  let translated = key
  if (_.isString(key)) {
    key = key.replace("'", '&#039;')

    if (translations[key]) {
      translated = translations[key]
    } else {
      // gaHelper.addError(4200200, key, gaHelper.CAT_WARN);
      console.warn(`no trans key: ${key}`)
    }

    if (replaceObj && _.isObject(replaceObj)) {
      _.forEach(replaceObj, (val, id) => {
        translated = replaceFn(translated, val, id)
      })
    }
  }
  return translated
}

trans.register = function register(key, val) {
  if (_.isString(key) && _.isString(val) && !translations[key]) {
    translations[key] = val
  }
}

module.exports = trans
